export enum DocumentsTypes {
  INVOICE = "invoice",
  DOUMENT = "document",
  SHIPMENT = "shipment",
  REMOVAL_SHIPMENT = "removal_shipment",
  AMAZON_RECEIPT = "amazon_receipt",
};